module.exports = __webpack_public_path__ + "872d362efaefb5e3bd7559d9de2729a8.pdf";